import { useMutation } from '@apollo/client'
import { Descriptions, Row, Space, Tabs, Tag, Typography } from 'antd'
import { uniqBy } from 'lodash'
import { PERSONNE_UPDATE_MUTATION } from '../../apollo/mutation/personne.mutation'
import lotHelper from '../../helpers/lot.helper'
import { D4_Personne } from '../../types'
import TableDemandeDeRappel from '../TableDemandeDeRappel'
import Actions from './Actions'
import ChequesTable from './ChequesTable'
import Equipe from './Equipe'
import Lots from './Lots'
import SmsTable from './SmsTable'
import StyledDescription from './StyledDescription'

/**
 * refus demat = papier
 * contenudematerialisation = 0
 * supportdematerialisation = 0
 * statutautorisationdematerialisation = 1
 */

const { TabPane } = Tabs

const PersonneDescription = ({ personne }: { personne: D4_Personne | undefined }) => {
  const [updatePersonne] = useMutation(PERSONNE_UPDATE_MUTATION)

  if (!personne) return null

  const handleChange = (key: string) => (value: string) => {
    updatePersonne({
      variables: {
        id: personne.id,
        data: { [key]: value },
      },
    })
  }

  const lots = uniqBy(personne.coproprietaire?.lot_coproprietaires, 'lot.copropriete.id')

  return (
    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px' }}>
      <Typography.Title level={4}>
        <Row justify="space-between" align="middle">
          <Space>
            {personne?.titre} {personne?.nom} {personne?.prenom}{' '}
            <Lots lots={personne?.coproprietaire?.lot_coproprietaires} />
          </Space>
          <Tag color={personne.comptevision?.actif ? 'green' : 'red'}>
            {personne.comptevision?.actif ? 'Actif' : 'Inactif'}
          </Tag>
        </Row>
      </Typography.Title>
      <div>{personne.adresse && lotHelper.normalizeAddresse(personne.adresse)}</div>
      <Actions coproprietaire={personne.coproprietaire} actif={personne.comptevision?.actif ?? false} />

      <StyledDescription size="small" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
        <Descriptions.Item label="Titre">
          <Typography.Text editable={{ onChange: handleChange('titre') }}>{personne.titre}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Nom">
          <Typography.Text editable={{ onChange: handleChange('nom') }}>{personne.nom}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Prenom">
          <Typography.Text editable={{ onChange: handleChange('prenom') }}>{personne.prenom}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Mail1">
          <Typography.Link
            href={`mailto:${personne.mail1}?subject=D4Immobilier`}
            editable={{ onChange: handleChange('mail1') }}
          >
            {personne.mail1}
          </Typography.Link>
        </Descriptions.Item>
        <Descriptions.Item label="Mail2">
          <Typography.Link
            href={`mailto:${personne.mail2}?subject=D4Immobilier`}
            editable={{ onChange: handleChange('mail2') }}
          >
            {personne.mail2}
          </Typography.Link>
        </Descriptions.Item>
        <Descriptions.Item label="Fixe">
          <Typography.Text editable={{ onChange: handleChange('telfixe') }}>{personne.telfixe}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Portable">
          <Typography.Text editable={{ onChange: handleChange('telportable') }}>{personne.telportable}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Équipe">
          <Equipe lots={lots} />
        </Descriptions.Item>
      </StyledDescription>
      <Tabs defaultActiveKey="rappel" type="card" style={{ marginBottom: 0 }}>
        <TabPane tab="Rappel" key="rappel">
          <TableDemandeDeRappel emetteurId={personne.id} />
        </TabPane>
        <TabPane tab="Cheque" key="cheque">
          <ChequesTable coproprietaireId={personne.coproprietaire?.id} />
        </TabPane>
        <TabPane tab="Sms" key="sms">
          <SmsTable personneId={personne.id} />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default PersonneDescription
